import React from "react";

function MandetoryUnAnsweredPopup({ setMandetoryPopup }) {
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/images/alert.svg" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg20">
          Please Answer the Mandatory Questions{" "}
        </div>
        <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
          <button
            className="okayBtnsucess"
            onClick={() => {
              setMandetoryPopup(false);
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default MandetoryUnAnsweredPopup;
